import { graphql, useStaticQuery } from 'gatsby'
import { RichText } from 'prismic-reactjs'
import React from 'react'

import htmlSerializer, { linkResolver } from '@somo/oxd-apps-www/src/utils/html-serializer'
import Page from '@cinch/oxd-pages/wbac/src'

const renderContent = (content: any) => RichText.render(content, linkResolver, htmlSerializer)

const SellCar: React.FC = () => {
  const data: any = useStaticQuery(graphql`
    query {
      prismic {
        sell(uid: "wbac", lang: "en-gb") {
          guarantee
          disclaimer
          transaction_fee
          payment_terms
        }
      }
      allTranslations {
        edges {
          node {
            sellVehicle {
              landing {
                title
                body
                numberPlate {
                  label
                  placeholder
                }
                ctaText
                ctaLabel
                poweredBy
                error
              }
              manualLookup {
                submit
              }
              car {
                panelTitle
              }
              questions {
                submit
                panelTitle
                carDetails
                yourDetails
              }
              valuation {
                panelTitle
                panelBody
                paymentInfo
                transactionFee
                ctaText
                getPaid
                pricePromise
                paymentTermsTitle
                paymentPanels {
                  hurry {
                    title
                    body
                    footer
                  }
                  nextDay {
                    title
                    body
                    footer
                  }
                  premierPayment {
                    title
                    body
                    footer
                  }
                }
                schedule {
                  title
                  selectLabel
                  milesAway
                  select
                  back
                  changePostcode
                  updatePostcode
                  cancel
                  dateLabel
                  timeLabel
                }
                valuationActions {
                  title
                  sellCtaLabel
                  findCtaLabel
                }
              }
            }
          }
        }
      }
    }
  `)
  const i18n = data.allTranslations.edges[0].node.sellVehicle
  const { sell } = data.prismic

  return (
    <>
      <Page
        i18n={i18n}
        content={{
          guarantee: renderContent(sell.guarantee),
          disclaimer: renderContent(sell.disclaimer),
          transaction: renderContent(sell.transaction_fee),
          paymentTerms: renderContent(sell.payment_terms),
        }}
      />
    </>
  )
}

export default SellCar
